export const MAX_CHALLENGES = 10;
export const ALERT_DELAY = 2000;
